import { values } from 'lodash'
import introspectionQueryResultData from '../generated/fragments.json'
import ApolloClient from 'apollo-boost'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import { fetchJwt } from '../utils'

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: 'INTERFACE',
          name: 'Task-Types',
          possibleTypes: values(introspectionQueryResultData.possibleTypes) as any[]
        }
      ]
    }
  }
})

const client = new ApolloClient({
  cache: new InMemoryCache({ fragmentMatcher }),
  request: async (operation) => {
    const token = await fetchJwt()
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })
  },
  uri: process.env.REACT_APP_API_HOST + '/graphql',
  onError: ({ graphQLErrors, networkError, response }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      )
    }
    if (networkError) {
      console.error(`[Network error]: ${networkError}`)
    }
    if (response && response.errors) {
      response.errors.forEach((error) => {
        console.error(`[Response error]: ${error.message}`)
      })
    }
  }
})

export default client
